import APIClient from '@/shared/http/clients/api'

// const resourceName = 'margem-contribuicao'
const resourceName = 'pix'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name PixRepository
 * @description Marge contribuição
 * @type { Respository }
 */
const PixRepository = {
  Search
}

export default PixRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/pix.js